export default __webpack_public_path__ + "static/media/bumpFundHero.d5502718.png";